/* eslint-disable */
import { assetImages } from "constants";
import { useEffect, useState } from "react";

/*import url and gateway methods */
import { getData, postData, putData, uploadMultipleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const CommentModal = ({ onModalClose, forumId, selectedCommentId }) => {
  const todayValue = new Date().toISOString().split("T")[0];

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const token = localStorage.getItem("token");

  const [description, setdescription] = useState("");
  const [isSubmiting, setIsSubmiting] = useState(false);

  const getCommentDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_COMMENT_DETAILS +
        `/${selectedCommentId}?token=${token}`;

      const response = await getData(requestURL);

      if (response.status) {
        setdescription(response.data.description);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const saveCommentHandler = async () => {
    setIsSubmiting(true);
    try {
      let forumData = {
        description,
      };

      let requestURL = url.API_BASE_URL;

      let response = null;

      if (selectedCommentId) {
        requestURL =
          requestURL +
          url.API_UPDATE_COMMENT +
          `/${selectedCommentId}?token=${token}`;

        response = await putData(requestURL, forumData);
      } else {
        requestURL =
          requestURL +
          url.API_ADD_COMMENT +
          `?token=${token}&forumid=${forumId}`;

        response = await postData(requestURL, forumData);
      }

      setIsSubmiting(false);
      resetHandler();

      console.log(response);

      if (response.status) {
        //hide login modal
        let postModal = document.querySelector("#activity_mdl");
        let modal = bootstrap.Modal.getInstance(postModal);
        modal.hide();

        onModalClose();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const resetHandler = () => {
    setdescription("");
  };

  useEffect(() => {
    if (selectedCommentId) {
      getCommentDetails();
    }
  }, [selectedCommentId]);

  return (
    <div className=" invite_modal common_modal">
      <div
        className="modal fade"
        id="activity_mdl"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 px-4">
              <div className="modal_hdng">
                <h3 className="text-primary text-uppercase fs-lg">
                  Add Comments
                </h3>
              </div>
              <button
                type="button"
                className="close d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetHandler}
              >
                <i className="material-icons-outlined">close</i>
              </button>
            </div>
            <div className="modal-body p-4">
              <form>
                <div className="invite_area">
                  <div className="invite_item mb-4">
                    <div className="comnts_user_outer d-flex align-items-center gap-3">
                      <div className="user_comnts rounded-circle overflow-hidden">
                        <img
                          src={
                            userInfo.photoimage
                              ? url.SERVER_URL + userInfo.photoimage?.path
                              : assetImages.defaultUser
                          }
                          className="h-100 w-100 object-cover"
                        />
                      </div>
                      <div className="cmnt_usr_info">
                        <h4 className="text-primary fs-lg fw-medium">
                          {userInfo.name} {userInfo.surname}
                        </h4>
                        <div className="time_tags rounded-90 px-2 py-1 d-inline-flex align-items-center gap-1 mt-2">
                          <i className="material-icons-outlined text-white fs-sm">
                            schedule
                          </i>
                          <span className="fs-sm text-white">{todayValue}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="invite_item mb-4">
                    <div className="input_fill description_fill">
                      <div className="editor_pnl">
                        <textarea
                          className="form-control bg-white p-3"
                          placeholder="Add your comments"
                          value={description}
                          onChange={(e) => setdescription(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="invite_item">
                    <div className="revw_submit d-flex gap-2 align-items-center">
                      <button
                        className="btn primary-btn w-100"
                        onClick={saveCommentHandler}
                        // data-bs-dismiss="modal"
                        disabled={isSubmiting ? true : false}
                        style={{
                          cursor: isSubmiting ? "not-allowed" : "pointer",
                        }}
                      >
                        Post Now
                        {isSubmiting && (
                          <div
                            className="mx-2 spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentModal;
